/**
 * Mixpanel SDK Loader for POV
 * POV owns the Mixpanel SDK and sends events directly
 */

const isIntegrationEnv = () => window.pov_config?.VUE_APP_ENV === 'integration';

export default function initMixpanel() {
  if (isIntegrationEnv()) {
    // eslint-disable-next-line no-console
    console.log('🔍 [Mixpanel Init] Disabled for integration environment - script not loaded');
    return;
  }

  /* eslint-disable */
  (function(f,b){if(!b.__SV){var a,e,i,g;window.mixpanel=b;b._i=[];b.init=function(a,e,d){function f(b,h){var a=h.split(".");2==a.length&&(b=b[a[0]],h=a[1]);b[h]=function(){b.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var c=b;"undefined"!==typeof d?c=b[d]=[]:d="mixpanel";c.people=c.people||[];c.toString=function(b){var a="mixpanel";"mixpanel"!==d&&(a+="."+d);b||(a+=" (stub)");return a};c.people.toString=function(){return c.toString(1)+".people (stub)"};i="disable track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user start_session_recording stop_session_recording".split(" ");
  for(g=0;g<i.length;g++)f(c,i[g]);b._i.push([a,e,d])};b.__SV=1.2;a=f.createElement("script");a.type="text/javascript";a.async=!0;a.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";e=f.getElementsByTagName("script")[0];e.parentNode.insertBefore(a,e)}})(document,window.mixpanel||[]);
  /* eslint-enable */

  const getMixpanelToken = () => {
    if (window.pov_config?.VUE_APP_MIXPANEL_TOKEN) {
      // eslint-disable-next-line no-console
      console.log('🔍 [Mixpanel Init] Token from pov_config (env var)');
      return window.pov_config.VUE_APP_MIXPANEL_TOKEN;
    }
    return null;
  };

  /**
   * Percentage of sessions to capture with Session Replay (0-100).
   * Precedence: localStorage override (for ad-hoc testing on feature envs) >
   * VUE_APP_MIXPANEL_RECORD_SESSIONS_PERCENT env var > 0 (recording off).
   * With remote_settings_mode: 'fallback' this value is only the fallback used
   * when Mixpanel's Remote Configuration is unavailable.
   */
  const getRecordSessionsPercent = () => {
    const override = window.localStorage?.getItem('mixpanel_record_sessions_percent');
    if (override) {
      const parsed = Number(override);
      if (!Number.isNaN(parsed)) return parsed;
    }
    const configured = Number(window.pov_config?.VUE_APP_MIXPANEL_RECORD_SESSIONS_PERCENT);
    return Number.isNaN(configured) ? 0 : configured;
  };

  // Data residency: US by default; set VUE_APP_MIXPANEL_API_HOST to
  // https://api-eu.mixpanel.com for EU tenants.
  const getApiHost = () => window.pov_config?.VUE_APP_MIXPANEL_API_HOST || null;

  // CSS selector for text/regions that must stay masked when text is unmasked
  // (used to protect PII once record_mask_all_text is false).
  const getMaskTextSelector = () => window.pov_config?.VUE_APP_MIXPANEL_MASK_TEXT_SELECTOR || null;

  const token = getMixpanelToken();

  if (token) {
    const recordSessionsPercent = getRecordSessionsPercent();
    // Session Replay only starts when recordSessionsPercent > 0 (or when
    // triggered via Remote Configuration).
    // record_mask_all_text: false shows on-screen text in replays; inputs stay
    // masked (record_mask_all_inputs defaults to true) and sensitive input
    // types (password/email/tel/hidden/autocomplete) are always masked.
    const config = {
      track_pageview: false,
      upgrade: true,
      record_sessions_percent: recordSessionsPercent,
      remote_settings_mode: 'fallback',
      record_mask_all_text: false,
    };

    const apiHost = getApiHost();
    if (apiHost) {
      config.api_host = apiHost;
    }

    const maskTextSelector = getMaskTextSelector();
    if (maskTextSelector) {
      config.record_mask_text_selector = maskTextSelector;
    }

    // eslint-disable-next-line no-console
    console.log(`🔍 [Mixpanel Init] Session Replay record_sessions_percent=${recordSessionsPercent}`);
    window.mixpanel.init(token, config);
  }
}
